import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ReactComponent as Person } from '../../images/person-gray-r.svg';
import { ReactComponent as Dot } from '../../images/gray-dot-r.svg';
import { ReactComponent as Meal } from '../../images/meal-r.svg';
import { ReactComponent as Star } from '../../images/gold-star-r.svg';
import { ReactComponent as Hotel } from '../../images/hotel-r.svg';
import {
  firstLetterInUpperCase,
  getNightsTextNoRange,
  getDayMonth,
  getMealText,
  getShortString,
  getHotelStars,
  formatHotelImageUrl,
  buildOrderUrl,
  formatPrice,
} from '../../Utils/CommonUtils';
import { TWO_ADULTS } from '../../Utils/Constants/GlobalConstants';
import './css/HotItem.css';
import PriceText from '../PriceText/PriceText';

function HotItem(props) {
  const { tour } = props;
  const backgroundImage = {
    backgroundImage: `url("${formatHotelImageUrl(tour.hotelpicture)}")`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
  };

  return (
    <div className="hot_item_w">
      <div>
        <div className="hot_item_hotel_img_w">
          <div className="hot_i_date_w">
            <div className="hot_i_date">{`${getDayMonth(
              tour.flydate,
            )} / ${getNightsTextNoRange(tour.nights)}`}</div>
          </div>
          <Hotel />
          <div style={backgroundImage} className="hot_i_hotel_img" />
        </div>
        <div className="hot_i_hotel_name">
          {`${firstLetterInUpperCase(
            getShortString(tour.hotelname, 37),
          )} ${getHotelStars(tour.hotelstars)}`}
        </div>
        <div className="hot_i_hotel_text mb_17">{`${tour.hotelregionname}, ${tour.countryname}`}</div>
      </div>
      <div>
        <div className="hot_tour_i_info_w">
          <div className="hot_i_tourists_w">
            <Person className="hot_i_person_ico" />
            <div className="hot_i_hotel_text">{TWO_ADULTS}</div>
            <Dot className="hot_i_dot_ico" />
          </div>
          <div className="hot_i_meal_w">
            <Meal className="hot_i_meal_ico" />
            <div className="hot_i_hotel_text">{getMealText(tour.meal)}</div>
          </div>
        </div>
        <div className="hot_i_price_w">
          <Link
            to={buildOrderUrl(tour.tourid)}
            target="_blank"
            type="button"
            className="hot_i_price_button blue_button"
          >
            <PriceText
              text={`${formatPrice(tour.price * 2)} ${tour.currency}`}
            />
          </Link>
          {tour.hotelrating && (
            <div className="hot_i_rating_w">
              <Star />
              <div className="hot_i_rating">{tour.hotelrating}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

HotItem.propTypes = {
  tour: PropTypes.instanceOf(Object).isRequired,
};

export default HotItem;
